import React from 'react'

const TextareaInput = ({placeholder, value, onValueChange}) => {
    return (
        <textarea className='w-full resize-none md:w-95.7% h-72 mt-10 border border-solid border-darkGrey rounded-lg outline-none p-5 placeholder' placeholder={placeholder}>

        </textarea>
    )
}

export default TextareaInput